import type { RouteRecordRaw } from 'vue-router'

/**
 * Super-admin de PLATAFORMA — gestión de bufetes.
 * platformOnly: solo navegable desde el dominio raíz (mode=platform).
 */
const routes: RouteRecordRaw[] = [
  {
    path: '/admin/plataforma',
    name: 'plataforma.dashboard',
    component: () => import('./views/PlataformaDashboard.vue'),
    meta: {
      layout: 'auth',
      requiresAuth: true,
      requiresPermission: 'bufetes.read',
      platformOnly: true,
      breadcrumb: 'Panel de plataforma',
    },
  },
  {
    path: '/admin/bufetes',
    name: 'plataforma.bufetes.index',
    component: () => import('./views/BufetesIndex.vue'),
    meta: {
      layout: 'auth',
      requiresAuth: true,
      requiresPermission: 'bufetes.read',
      platformOnly: true,
      breadcrumb: 'Bufetes',
    },
  },
  {
    path: '/admin/bufetes/:id',
    name: 'plataforma.bufetes.detalle',
    component: () => import('./views/BufeteDetalle.vue'),
    meta: {
      layout: 'auth',
      requiresAuth: true,
      requiresPermission: 'bufetes.read',
      platformOnly: true,
      breadcrumb: 'Detalle del bufete',
    },
  },
  {
    path: '/admin/planes',
    name: 'plataforma.planes.index',
    component: () => import('./views/PlanesIndex.vue'),
    meta: {
      layout: 'auth',
      requiresAuth: true,
      requiresPermission: 'bufetes.read',
      platformOnly: true,
      breadcrumb: 'Planes',
    },
  },
]

export default routes
